import { PlusIcon } from "lucide-react";

import { openNewRuleFlow } from "@/app/app/_/commands/utils";

import { DataViewModeToggle } from "@/components/organisms/DataView/DataViewModeToggle";
import { UtilityBar } from "@/components/organisms/UtilityBar";
import { AppViewSubnavAction } from "@/layouts/AppLayout/AppTopbar/AppViewSubnav";
import { State } from "@/state";

/** The list's table or cards toggle; a rule's own page has neither. */
export function RulesLeading() {
  const activeTab = State((state) => state.activeTab);
  const selectedRuleId = State(
    (state) => (state.activeTabNodeIds as any)?.rules?.[activeTab],
  );
  return selectedRuleId ? null : <DataViewModeToggle />;
}

export function RulesSubnav() {
  const activeTab = State((state) => state.activeTab);
  const selectedRuleId = State(
    (state) => (state.activeTabNodeIds as any)?.rules?.[activeTab],
  );

  if (selectedRuleId) {
    return null;
  }

  return <UtilityBar />;
}

export function RulesActions() {
  const activeTab = State((state) => state.activeTab);
  const selectedRuleId = State(
    (state) => (state.activeTabNodeIds as any)?.rules?.[activeTab],
  );

  // A rule's page has nothing to add to the toolbar; the list has a new rule.
  if (selectedRuleId) {
    return null;
  }

  return (
    <AppViewSubnavAction
      icon={<PlusIcon />}
      onClick={openNewRuleFlow}
      data-testid="new-rule-btn"
    >
      New rule
    </AppViewSubnavAction>
  );
}
